/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-useless-concat */

'use strict';

var focusHelper = require('base/components/focus');
var afterpayWidget = require('../product/afterpayWidget');
var klarnaOsm = require('../common/klarnaOsm');
var afterpayMobileContent = require('../product/afterpayContent');
var carouselConfig = require('../components/carousel-config');
var utils = require('../utils');
var getAmountToDisplay = utils.getAmountToDisplay;

/**
 * Fill Product Name
 */
function fillProductName() {
    var $editProductModal = $('#editProductModal');
    if ($editProductModal.length) {
        var $displayColorName = $editProductModal.find('.color-name-desktop');
        var $mobileProductColorName = $editProductModal.find('.color-name-mobile');
        if ($displayColorName.length && $mobileProductColorName.length) {
            var selectedColor = $displayColorName.text();
            $mobileProductColorName.html(selectedColor);
        }
    }
}

/**
 * Toggle wish list icon on selection
 * @param {boolean} isAvailableInWishlist true to make active wishlist icon.
 */
function toggleWishListIcon(isAvailableInWishlist) {
    var $canWishList = $('.cart-wl.add-to-wishlist');
    var $wishlistedProduct = $('.cart-wl.added-to-wishlist');
    if ($canWishList.length && $wishlistedProduct.length) {
        if (isAvailableInWishlist) {
            $canWishList.addClass('d-none');
            $wishlistedProduct.removeClass('d-none');
        } else {
            $canWishList.removeClass('d-none');
            $wishlistedProduct.addClass('d-none');
        }
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. If invalid disables checkout button and hides
 * express payment options
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    var $validCartError = $('.cart-error-messaging.cart-error .valid-cart-error');
    var $cartContainers = $('.container.cart, .minicart-footer'); // cart and minicart containers
    var $afterPayCartTotal = $('.afterpay-carttotal');

    if ($validCartError && $validCartError.length > 0) {
        $validCartError.remove();
    }

    if (data.valid) {
        if (data.valid.error) {
            if (!data.valid.message) {
                window.location.reload();
            }

            $cartContainers.find('.checkout-btn').addClass('disabled');
            $cartContainers.find('.payment-options').addClass('d-none');
            $afterPayCartTotal.addClass('d-none');
        } else {
            $cartContainers.find('.checkout-btn').removeClass('disabled');

            if (!data.isOrderTotalGMPCovered) {
                $cartContainers.find('.payment-options').removeClass('d-none');
                $afterPayCartTotal.removeClass('d-none');
            }
        }
    }
}

/**
 * Update discount promotions on minicart
 * @param {Object} discounts promotion discounts list
 */
function updateDiscountPromotions(discounts) {
    var $promotionInformation = $('.promotion-information');
    var $approachingDiscounts = $('.approaching-discounts');
    if ($promotionInformation.length) {
        $promotionInformation.empty();
        var promotionDiscounts = '';
        discounts.forEach(function (item) {
            promotionDiscounts += '<span class="promotion-name my-2">'
                + item.lineItemText + '</span>';
        });
        $promotionInformation.append(promotionDiscounts);
        // Empty approach discounts any previously when promotions applied
        if ($approachingDiscounts.length) {
            $approachingDiscounts.empty();
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append('(' + data.numItems + ')');
    if ($('p.shipping-cost').length > 0) {
        $('p.shipping-cost').empty().append(getAmountToDisplay(data.totals.totalShippingCost));
    } else {
        $('.shipping-total-cost').empty().append(getAmountToDisplay(data.totals.totalShippingCost));
    }
    $('p.shipping-cost').empty().append(getAmountToDisplay(data.totals.totalShippingCost));
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(getAmountToDisplay(data.totals.grandTotal));
    $('.sub-total').empty().append(getAmountToDisplay(data.totals.subTotal));
    $('.shipping-methods-summary').html(data.renderedShippingMethods);

    // Updates Pricebook Discounts
    $('body').trigger('listDiscountUpdate', data);

    // check numItems exists in response
    if (data.numItems) {
        $('.item-count-value').empty().append(data.numItems);

        if (data.numItems === 1) {
            $('.item-count-label-single').removeClass('d-none');
            $('.item-count-label-multi').addClass('d-none');
        } else {
            $('.item-count-label-single').addClass('d-none');
            $('.item-count-label-multi').removeClass('d-none');
        }

        if (data.numItems > 99) {
            $('.minicart-quantity').empty();
        } else {
            $('.minicart-quantity').empty().append(data.numItems);
        }
    }

    var orderLevelDiscounts = data && data.totals && data.totals.orderDiscountsTemplate ? data.totals.orderDiscountsTemplate : '';
    $('#js-order-level-dicounts').empty().html(orderLevelDiscounts);

    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    var cartNum = $('.minicart-items-container .cart-number').data('cart-label') + ' (' + data.numItems + ')';
    $('.minicart-items-container .cart-number').text(cartNum);

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + getAmountToDisplay(data.totals.orderLevelDiscountTotal.formatted));
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- '
            + getAmountToDisplay(data.totals.shippingLevelDiscountTotal.formatted));
        // if (data.totals.shippingLevelDiscountTotal.value === data.totals.totalShippingCostValue) { //commented for SFRA-6148
        // $('p.shipping-cost').empty().append(data.resources.freeLabel);
        // }
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.totals.gcTotal && data.totals.gcTotal.value > 0) {
        $('.giftcertificate-item').removeClass('d-none');
        $('.gift-card-total').text('- ' + data.totals.gcTotal.formatted);
    } else {
        $('.giftcertificate-item').addClass('d-none');
    }

    if (data.totals && data.totals.discounts && data.totals.discounts.length) {
        updateDiscountPromotions(data.totals.discounts);
    }

    data.items.forEach(function (item) {
        $('.item-' + item.UUID).empty();
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).append(item.renderedPromotions);
        }
        if (item.markdownDiscount) {
            $('.item-' + item.UUID).append(`<div class="mt-1">${item.markdownDiscount}</div>`);
        }
        if (!item.renderedPromotions && item.cartCalloutMessage) {
            $('.item-' + item.UUID).append(`<div class="mt-1">${item.cartCalloutMessage}</div>`);
        }
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.checkout-item-price-summary-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var approachingDiscountsContent = '';
    var $promotionInformation = $('.promotion-information');
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            approachingDiscountsContent += '<span class="body-bold pr-1">'
                + item.discountMsg + '.</span>';
        });
        // To make empty all applicable discount promotions
        if ($promotionInformation.length) {
            $promotionInformation.empty();
        }
    }
    $('.approaching-discounts').append(approachingDiscountsContent);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i += 1) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem = { UUID: '' };
    var messages = '';
    var shippingMethodCardID = '';

    for (var i = 0; i < data.items.length; i += 1) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                if (message && message.indexOf('not available') > -1) {
                    var fullyOOS = false;
                    if (lineItem.variationAttributes) {
                        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
                            return attr.attributeId === 'style';
                        });
                        if (colorAttr) {
                            fullyOOS = colorAttr.fullyOOSInd;
                        }
                    }
                    if (lineItem.variantCount === 1 || fullyOOS) {
                        messages += '<p class="line-item-attributes oos-item-js">' + data.resources.fullyOOSMsg + '</p>';
                    } else {
                        messages += '<p class="line-item-attributes oos-item-js">' + data.resources.itemUnavailableMsg + '</p>';
                    }
                }
            });
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);

    shippingMethodCardID = '.product-info.uuid-' + lineItem.UUID + ' .shipping-method-card';
    // Need this check to prevent the shipping-method-card from always being hidden when product line item quantity is updated
    if ($(shippingMethodCardID).hasClass('pre-order')) {
        $(shippingMethodCardID).removeClass('pre-order').addClass('d-none');
    }

    if (lineItem.availability.preOrder) {
        $('.product-info.uuid-' + lineItem.UUID + ' .shipping-method-card .method div').addClass('pre-order').empty().html('<div class="preorder-label">' + data.resources.preOrderTitle + '</div><div class="preorder-instockdate">' + data.resources.preOrderMsg + ' ' + lineItem.availability.inStockDate + '</div>');
        $(shippingMethodCardID).addClass('pre-order').removeClass('d-none');
    }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'style';
        });

        if (colorAttr) {
            var $colorSelector = $('.' + colorAttr.attributeId + '-' + uuid);
            if ($colorSelector.length) {
                var $colorAttrValue = $colorSelector.find('.attribute-value');
                if ($colorAttrValue.length) {
                    $colorAttrValue.text(colorAttr.displayValue);
                }
            }
        }

        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'size';
        });

        if (sizeAttr) {
            var $sizeSelector = $('.' + sizeAttr.attributeId + '-' + uuid);
            if ($sizeSelector.length) {
                var $sizeAttrValue = $sizeSelector.find('.attribute-value');
                if ($sizeAttrValue.length) {
                    $sizeAttrValue.text(sizeAttr.displayValue);
                }
            }
        }

        var widthAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === 'width';
        });

        if (widthAttr) {
            var $widthSelector = $('.' + widthAttr.attributeId + '-' + uuid);
            if ($widthSelector.length) {
                var $widthAttrValue = $widthSelector.find('.attribute-value');
                if ($widthAttrValue.length) {
                    $widthAttrValue.text(widthAttr.displayValue);
                }
            }
        }

        var imageSelector = '.product-info.uuid-' + uuid + ' .item-image .product-image';
        $(imageSelector).attr('src', lineItem.images.cartPage[0].url);
        $(imageSelector).attr('alt', lineItem.images.cartPage[0].alt);
        $(imageSelector).attr('title', lineItem.images.cartPage[0].title);

        var imageContainer = '.product-info.uuid-' + uuid;
        if (lineItem.availability.isInStock && $(imageContainer + ' .item-image').hasClass('oos-cart-item')) {
            $(imageContainer + ' .item-image').removeClass('oos-cart-item');
            $(imageContainer + ' span.oos-message').remove();
        }
    }

    if (lineItem.options && lineItem.options.length) {
        var option = lineItem.options[0];
        var optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
        $(optSelector).data('value-id', option.selectedValueId);
        $(optSelector + ' .line-item-attributes').text(option.displayName);
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var editModalHeading = $('#cartEditProductHeading').val();
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog-js">'
        + '<!-- Modal content-->'
        + '<div class="modal-content nb-modal__panel">'
        + '<div class="modal-header px-3">'
        + '<div class="font-body-large font-weight-semibold font-subheader-lg-3 bold-lg">' + editModalHeading + '</div>'
        + '    <button type="button" class="close mr-0 pt-3" data-dismiss="modal">'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body px-3 px-lg-4 pt-2 pt-lg-8"></div>'
        + '<div class="modal-footer px-3 px-lg-4 pt-3 pt-lg-0 mx-0 ml-lg-3 mr-lg-5"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            var $editProductModal = $('#editProductModal');

            $editProductModal.find('.modal-body').empty().html(parsedHtml.body);
            $editProductModal.find('.modal-footer').html(parsedHtml.footer);
            $editProductModal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            $editProductModal.find('.enter-message').text(data.enterDialogMessage);
            $editProductModal.modal('show');
            $('.carousel').carousel({ wrap: false });
            afterpayWidget.getWidget(data.product.id, data.product.price.sales.value, 'pdp-afterpay-message');
            if (afterpayMobileContent && afterpayMobileContent.init && typeof afterpayMobileContent.init === 'function') {
                afterpayMobileContent.init();
            }
            carouselConfig.toggleCarouselControls($editProductModal);
            fillProductName();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Open Minicart after delete/cancel
 */
function openMinicart() {
    $('.minicart').trigger('open:minicart');
}
/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {string} gender - gender to be displayed
 * @param {string} image - URL of the image to be displayed
 * @param {string} price - product price
 * @param {boolean} isInStock - product in stock
 * @param {string} wishlistUrl - URL to check if item exists in Wish list
 * @param {boolean} isRemoveMinicart - Indicates if confirm modal is triggered from MiniCart
 * @param {string} productDetailsUrl - product details url
 * @param {string} initiator - Indicated where the modal was triggered
 */
function confirmDelete(actionUrl, productID, productName, uuid, gender, image, price, isInStock, wishlistUrl, isRemoveMinicart, productDetailsUrl, initiator) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productName = $('.product-to-remove');
    var $productGenderSpan = $('.product-gender');
    var $productImageSpan = $('.remove-item .product-image');
    var $productIdSpan = $('.cart-product-id');
    var $productAddToWL = $('.product-move a.move');
    var $removeProductModal = $('#removeProductModal');
    var $productPriceSpan = $removeProductModal.find('.product-price');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    $deleteConfirmBtn.data('isremoveminicart', isRemoveMinicart);
    $deleteConfirmBtn.data('initiator', initiator);

    if (isRemoveMinicart) {
        $('.minicart .popover').removeClass('show');
    }

    if ($productName.length) {
        $productName.empty().append(productName);
        if (productDetailsUrl) {
            $productName.attr('href', productDetailsUrl);
        }
    }
    $productGenderSpan.empty().append(gender);
    $productImageSpan.empty().append(image);
    $productPriceSpan.empty().append(price);
    $productImageSpan.attr('src', image);
    $productIdSpan.empty().append(productID);
    $productAddToWL.attr('data-pid', productID);
    $productAddToWL.attr('data-name', productName);
    $productAddToWL.attr('data-uuid', uuid);

    if ($removeProductModal.length) {
        var $productActions = $removeProductModal.find('.product-actions');
        $removeProductModal.find('.modal-footer').append($productActions);
    }

    if (isInStock) {
        $.ajax({
            url: wishlistUrl,
            type: 'get',
            dataType: 'json',
            data: {
                pid: productID,
                jsonResponse: true
            },
            success: function (data) {
                if (data.itemExistsFlag) {
                    toggleWishListIcon(data.itemExistsFlag);
                } else {
                    toggleWishListIcon();
                    $('.add-to-wl-text').html('<u>' + data.moveToWishlistLink + '</u>');
                }
            },
            error: function () {
            }
        });
    } else {
        $('.cart-wl.add-to-wishlist, .cart-wl.added-to-wishlist').addClass('d-none');
    }
}

/**
 * Call wishlist add/remove
 * @param {boolean} add True if add to wishlist, false if not
 */
function addRemoveWishlist(add) {
    var $this = $(this);
    var url = $this.data('href');
    var pid = $('.cart-product-id').text();
    var optionId = $this.closest('.delete-confirmation-body').find('.product-option').attr('data-option-id');
    var optionVal = $this.closest('.delete-confirmation-body').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;
    var requestType = 'get';
    if (add) {
        toggleWishListIcon(add);
        requestType = 'post';
    } else {
        toggleWishListIcon();
    }

    if (!url) {
        return;
    }

    $.ajax({
        url: url,
        type: requestType,
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal
        },
        success: function () {
        },
        error: function () {
        }
    });
}

/**
 * Moves product cards between the fufillment sections (BOPIS and Standard) based on the selected cart fulfillment method
 * @param {string} currentProductUuid - the uuid of the product card to replace
 * @param {string} renderedNewProductCardHtml - rendered new product HTML
 * @param {string} cartFulfillmentSection - section product card is being moved to
 * @param {string} updatedProductUUID - new product card uuid
 */
function moveProductCardToCorrectSection(currentProductUuid, renderedNewProductCardHtml, cartFulfillmentSection, updatedProductUUID) {
    var $currentProductCard = $('.product-info.uuid-' + currentProductUuid);
    var $currentSection = $currentProductCard.closest('.cart-items-section');

    // remove the product card from the current section
    $currentProductCard.remove();

    // if the current section is empty, hide it
    if ($currentSection && $currentSection.children('.product-info').length === 0) {
        $currentSection.addClass('d-none');
    }

    // determine the new section to move the product card to
    var $newSection = null;
    if (cartFulfillmentSection === 'bopisMethodRadioButton') {
        $newSection = $('#bopis-items');
    } else {
        $newSection = $('#standard-items');
    }

    // show the new section if it was hidden
    $newSection.removeClass('d-none');

    // add the product card to the new section
    var $updatedProductCard = $('.product-info.uuid-' + updatedProductUUID);
    if ($updatedProductCard.length) {
        $updatedProductCard.replaceWith(renderedNewProductCardHtml);
    } else {
        $newSection.find('hr').before(renderedNewProductCardHtml);
    }
}

/**
 * Populates the bopis cart section header details
 * @param {string} store - the store object
 * @param {string} shipment - the shipment uuid
 */
function updateBopisStoreHeader(store, shipment) {
    if (!store || !shipment) {
        return;
    }

    var $bopisSection = $('#bopis-items');
    var $storeName = $('#storeName');
    var $storeStateCode = $('#storeStateCode');

    $bopisSection.data('storeId', store.ID);

    if ($storeName.length && $storeStateCode.length) {
        $storeName.text(store.name);
        $storeStateCode.text(', ' + store.stateCode);
    }
}

/**
 * Update and replace displayed cart data with any changes for line items from
 * the UpdateQuantity controller
 *
 * @param {Object} data - response data from UpdateQuantity controller
 * @param {string} productID - product ID
 * @param {string} uuid - line item UUID
 * @param {string} preSelectQty - line item quantity prior to change
 * @param {string} quantity - line item quantity after change
 */
function updateCartOnQuantityChange(data, productID, uuid, preSelectQty, quantity) {
    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);

    updateCartTotals(data);
    updateApproachingDiscounts(data.approachingDiscounts);
    updateAvailability(data, uuid);
    validateBasket(data);
    klarnaOsm.updateTotal(data.totals.grandTotal.replace(/[NZA$]/g, ''));
    afterpayWidget.getWidget(null, data.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');

    // replace "@ XX.XX each" text for current line item according to quantity
    $(this).data('pre-select-qty', quantity);
    var lineItem = findItem(data.items, function (item) {
        return item.UUID === uuid;
    });
    var $priceContainer;
    if (lineItem && quantity !== '1' && $('.product-info.uuid-' + uuid + ' .line-item-quantity .each-item-price').length === 0) {
        $priceContainer = '<span class="each-item-price regular ml-2">' + data.resources.textAt + ' <div class="price"><span class="sales">' + lineItem.price.sales.formatted
        + ' </span>' + data.resources.textEach + ' </div></span>';
        $('.product-info.uuid-' + uuid + ' .line-item-quantity').append($priceContainer);
    } else if (quantity === '1') {
        $('.product-info.uuid-' + uuid + ' .line-item-quantity .each-item-price').remove();
    }

    // trigger tealium cart change events
    $('body').trigger('cart:update');
    if (window.utag_data) {
        if (parseInt(preSelectQty, 10) > quantity) {
            if (window.utag_data.page_name === 'my cart' && $(this).parents('.minicart').length === 0) {
                $(document).trigger('cart:update-quantity', ['cart_remove_cart_quantity', 'Confirm Remove Product | Cart', productID]);
            } else {
                $(document).trigger('cart:update-quantity', ['cart_remove_mini_cart_quantity', 'Confirm Remove Product | Mini Cart', productID]);
            }
        } else if (window.utag_data.page_name === 'my cart' && $(this).parents('.minicart').length === 0) {
            $(document).trigger('cart:update-quantity', ['cart_add_cart', 'Add to Cart | Cart', productID]);
        } else {
            $(document).trigger('cart:update-quantity', ['cart_add_mini_cart', 'Add to Cart | Mini Cart', productID]);
        }
    }
}

/**
* cart page scroll to error message
*/
function cartScrollPage() {
    setTimeout(function () {
        if ($(document).find('.availability-message p.line-item-attributes').text().length > 0) {
            var scrollPage = $(document).find('.availability-message p.oos-item-js').first().offset().top;
            $(window).scrollTop(scrollPage - 120);
        }
    }, 3000);
} cartScrollPage();

/**
 * Initiate request to modify basket based on product fulfillment method change and
 * update cart display using response
 * @param {string} actionURL - request URL
 * @param {Object} queryParams - request query parameters
 * @param {string} productUUID - product UUID
 * @param {string} sectionClicked - fulfillment type clicked
 */
function updateCartOnProductFulfillmentChange(actionURL, queryParams, productUUID, sectionClicked) {
    $.spinner().start();
    $.ajax({
        url: appendToUrl(actionURL, queryParams),
        type: 'get',
        dataType: 'json',
        success: function (res) {
            try {
                // Update line item(s) on cart
                moveProductCardToCorrectSection(productUUID, res.updatedProductCard, sectionClicked, res.updatedProductLineItemUUID[0]);
                updateBopisStoreHeader(res.store, res.shipment);
                updateCartTotals(res.basket);
                updateApproachingDiscounts(res.basket.approachingDiscounts);
                updateAvailability(res.basket, res.updatedProductLineItemUUID[0]);
                validateBasket(res.basket);
                klarnaOsm.updateTotal(res.basket.totals.grandTotal.replace(/[NZA$]/g, ''));
                afterpayWidget.getWidget(null, res.basket.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
            } catch (err) {
                $.spinner().stop();
            }
        },
        error: function () {
            $.spinner().stop();
        },
        complete: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Show or hide the regular payment options i.e. coupons and gift cards cover the entire order total.
 * @param {Object} response - The API response object
 */
function showOrHidePaymentOptions(response) {
    if (response.isOrderFree) {
        $('.giftcard-payment-instrument').remove();
        $('#giftCertID').val('');
        $('#giftCertPin').val('');
    }

    var showPaymentMethodSection = response.remainingPaymentAmount > 0;
    var paymentMethodSection = $('.payment-container');
    $('.entire-order-reedemed').remove();
    if (showPaymentMethodSection) {
        paymentMethodSection.removeClass('d-none');
    } else {
        paymentMethodSection.removeClass('d-none').addClass('d-none');
        $('.payment-section').append('<div class="entire-order-reedemed mt-1 font-subheader-3 font-header-lg-3 bold font-weight-semibold-lg mt-0 mt-lg-2 mb-2 mb-lg-4 pb-0 pb-lg-2">' + response.gcfullyPaidMsg + '</div>');
    }
}

module.exports = function () {
    cartScrollPage();

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();
        var $this = $(this);
        var isRemoveMinicart = $(this).closest('.minicart');
        var actionUrl = $this.data('action');
        var productID = $this.data('pid');
        var productName = $this.data('name');
        var uuid = $this.data('uuid');
        var gender = $this.data('gender');
        var image = $this.data('image');
        var price = $this.data('price');
        var isInStock = $this.data('availability');
        var wishlistUrl = $this.data('href');
        var productDetailsUrl = $this.data('productUrl');
        var initiator = $this.data('initiator');
        confirmDelete(actionUrl, productID, productName, uuid, gender, image, price, isInStock, wishlistUrl, isRemoveMinicart.length, productDetailsUrl, initiator);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid, data.gender, data.image, data.price, data.isInStock, data.wishlistUrl);
    });

    $('body').on('cart:updateCartTotals', function (e, data) {
        e.preventDefault();
        updateCartTotals(data);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('.cancel-delete').on('click', function () {
        var isRemoveMinicart = $('.cart-delete-confirmation-btn').data('isremoveminicart');

        if (isRemoveMinicart) {
            openMinicart();
        }
    });

    $('body').on('click', '.cart-delete-confirmation-btn, button.remove-item', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var isRemoveMinicart = $(this).data('isremoveminicart');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);
        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    window.location.reload();
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i += 1) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }

                    var $productCardToRemove = $('.uuid-' + uuid);
                    var $productCardSection = $productCardToRemove.closest('.cart-items-section');

                    // hide entire section if this is the last product card in it
                    if ($productCardSection && $productCardSection.children('.product-info').length === 1) {
                        $productCardSection.hide();
                    }

                    $productCardToRemove.remove();

                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }

                    if (!data.isMixedCart) {
                        $('.cart-checkout-buttons').removeClass('d-none');
                        $('.preorder-cart-msg').addClass('d-none');
                    }

                    if (data.hasPreOrder || data.hasBackOrder) {
                        $('.cart-paypal').addClass('d-none');
                    } else {
                        $('.cart-paypal').removeClass('d-none');
                    }

                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                    klarnaOsm.updateTotal(data.basket.totals.grandTotal.replace(/[NZA$]/g, ''));
                    afterpayWidget.getWidget(null, data.basket.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
                }
                $(window).scrollTop(0);
                $.spinner().stop();

                if (data.basket.items.length && isRemoveMinicart) {
                    $('.minicart').trigger('open:minicart');
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    // cart updates for quantity selector dropdown change
    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.product-info').spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                // update quantity dropdown selector value
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);

                // update quantity -/+ buttons value (to account for quantity change using minicart while it still uses the old dropdown selector)
                var $form = $('.item-quantity-form[data-uuid="' + uuid + '"]');

                if ($form && $form.length) {
                    $form.data('quantity', quantity);
                    $form.find('.item-quantity-value').empty().append(quantity);
                }

                updateCartOnQuantityChange(data, productID, uuid, preSelectQty, quantity);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    // user was prompted to select a store when changing fulfillment for a product and has now selected one
    $('body').on('cart:promptStoreSelected', function (e, productUUID, storeID) {
        var $productCard = $('.product-info.uuid-' + productUUID);
        var sectionClicked = 'bopisMethodRadioButton';
        var $fulfillmentSelector = $productCard.find('#' + sectionClicked);
        var actionUrl = $fulfillmentSelector.data('action-url');
        var queryParams = {
            productLineItemId: productUUID,
            storeId: storeID
        };

        updateCartOnProductFulfillmentChange(actionUrl, queryParams, productUUID, sectionClicked);
    });

    $('body').on('change', '.js-fufillment-radio-btn', function () {
        var actionUrl = $(this).data('action-url');
        var currentProductUuid = $(this).data('uuid');
        var sectionClicked = $(this).attr('id');

        var queryParams = {
            productLineItemId: currentProductUuid
        };

        if (sectionClicked === 'bopisMethodRadioButton') {
            var storeID = $('#bopis-items').data('store-id');

            if (storeID) {
                queryParams.storeId = storeID;
            } else {
                // no preferred store set, prompt user to select a store
                $(this).prop('checked', false);
                $('body').trigger('cart:promptStoreSelection', [currentProductUuid]);
                return;
            }
        }

        updateCartOnProductFulfillmentChange(actionUrl, queryParams, currentProductUuid, sectionClicked);
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    klarnaOsm.updateTotal(data.totals.grandTotal.replace(/[NZA$]/g, ''));
                    afterpayWidget.getWidget(null, data.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').on('submit', function (e) {
        e.preventDefault();
        $.spinner().start();
        var $couponErrorMsg = $('.coupon-error-message');
        var $couponFormControl = $('.promo-code-form .form-control');
        $couponErrorMsg.empty();
        var $form = $('.promo-code-form');
        $couponFormControl.removeClass('is-invalid');
        $couponErrorMsg.empty();

        var url = $form.attr('action');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $couponFormControl.addClass('is-invalid').attr('aria-describedby', 'invalidCouponCode');
                    $couponErrorMsg.empty().append(data.errorMessage).addClass('filled-error-message');
                    $.spinner().stop();
                    return;
                }
                $couponErrorMsg.removeClass('filled-error-message');
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                $form.find('.redeem-another-promo').removeClass('d-none');
                $form.find('.promo-code-btn').addClass('d-none');
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                klarnaOsm.updateTotal(data.totals.grandTotal.replace(/[NZA$]/g, ''));
                afterpayWidget.getWidget(null, data.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
                document.dispatchEvent(new Event('couponAdd'));

                $('.coupon-code-field').val('');

                if ($('.promo-codes-loyalty-container .custom-control-input').length > 0) {
                    var discounts = data.totals.discounts;
                    var couponCode = null;
                    var couponUUID = null;
                    if (discounts && discounts.length > 0) {
                        discounts.forEach(function (item) {
                            if (item.couponCode && item.applied) {
                                couponCode = item.couponCode;
                                couponUUID = item.UUID;
                            }
                        });
                    }
                    if (couponCode && couponUUID) {
                        $('.promo-codes-loyalty-container .custom-control-input').each(function (i, el) {
                            if ($(el).attr('data-promocode') === couponCode) {
                                $(el).prop('disabled', false);
                                $(el).prop('checked', true);
                                $(el).data('uuid', couponUUID);
                            } else {
                                $(el).prop('disabled', true);
                                $(el).prop('checked', false);
                            }
                        });
                    }
                    $form.find('.redeem-another-promo').addClass('d-none');
                    $form.find('.promo-code-btn').removeClass('d-none');
                }

                showOrHidePaymentOptions(data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    // Redeem another promo code functionality
    $('.promo-code-form .another-promo-link').on('click', function () {
        $('.redeem-another-promo').addClass('d-none');
        $('.promo-code-form .promo-code-btn').removeClass('d-none');
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                klarnaOsm.updateTotal(data.totals.grandTotal.replace(/[NZA$]/g, ''));
                afterpayWidget.getWidget(null, data.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
                $('.promo-codes-loyalty-container .custom-control-input').each(function (i, el) {
                    $(el).prop('checked', false);
                    $(el).prop('disabled', false);
                });
                $('.redeem-another-promo').addClass('d-none');
                $('.promo-code-form .promo-code-btn').removeClass('d-none');

                showOrHidePaymentOptions(data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                import(/* webpackChunkName: "prod-base-chunk" */ '../product/base').then(function (productBase) {
                    productBase.editBonusProducts(data);
                    $.spinner().stop();
                });
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('slid.bs.carousel', '#editProductModal', function () {
        carouselConfig.toggleCarouselControls($('#editProductModal'));
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog-js');
        var preOrderFlag = response.product.availability.preOrder;
        var backorderFlag = response.product.availability.backorder;
        if (preOrderFlag !== undefined && preOrderFlag) {
            $('.cart-and-ipay .button-label').text(response.product.availability.preOrderMsg);
            $('.cart-and-ipay .add-to-cart').attr('data-preorder', 'true');
        } else if (backorderFlag !== undefined && backorderFlag) {
            $('.cart-and-ipay .button-label').text(response.product.availability.backorderMsg);
            $('.cart-and-ipay .add-to-cart').attr('data-backorder', 'true');
        } else {
            $('.cart-and-ipay .button-label').text(response.product.availability.isInstockMsg);
        }
        $('.update-cart-product-global', dialog).attr('disabled',
            (!$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')) && response.product.selectedQuantity < response.product.availability.productsLeft);
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog-js');

        if (response.product.selectedQuantity > response.product.availability.productsLeft) {
            $('.modal.show .update-cart-url').data('selected-quantity', 1);
        }

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $editProductModal = $('#editProductModal');

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        if (!updateProductUrl) {
            return;
        }

        $editProductModal.spinner().start();

        import(/* webpackChunkName: "prod-base-chunk" */ '../product/base').then(function (productBase) {
            var selectedQuantity = $this.closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
            var selectedOptionValueId = $this.closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
            var uuid = $this.closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
            var form = {
                uuid: uuid,
                pid: productBase.getPidValue($this),
                quantity: selectedQuantity,
                selectedOptionValueId: selectedOptionValueId
            };

            var csrfName = $('.csrf-edit-prod').attr('name');
            var csrfValue = $('.csrf-edit-prod').val();
            form[csrfName] = csrfValue;

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $editProductModal.spinner().stop();
                    $editProductModal.modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update');

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err && err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $.spinner().stop();
                        $editProductModal.spinner().stop();
                    }
                }
            });
        });
    });

    $('.cart-add-to-wishlist').on('click', function (e) {
        e.preventDefault();
        addRemoveWishlist.call(this, true);
    });
    $('.cart-remove-from-wishlist').on('click', function (e) {
        e.preventDefault();
        addRemoveWishlist.call(this, false);
    });

    $('body').on('click', '.checkout-btn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var checkoutUrl = $this.attr('href');
        var gcPaymentsLength = $('.gc-payments').val();
        if (gcPaymentsLength && gcPaymentsLength !== '0' && gcPaymentsLength !== 'null') {
            $.ajax({
                url: $this.data('gc-url'),
                type: 'GET',
                dataType: 'json',
                success: function () {
                    window.location.href = checkoutUrl;
                },
                error: function () {
                    window.location.href = checkoutUrl;
                }
            });
        } else {
            window.location.href = checkoutUrl;
        }
    });

    // cart updates for quantity plus/minus buttons change
    $(document).on('click', 'button.qty-decrease, button.qty-increase', function (e) {
        e.preventDefault();
        var $button = $(this);
        var $form = $button.parent();
        var buttonAction = $button.data('action');
        var formData = $form.data();
        var quantity = parseInt(formData.quantity, 10);
        var quantityMin = parseInt(formData.quantityMin, 10);
        var quantityMax = parseInt(formData.quantityMax, 10);
        var quantityNew = quantity;
        var productID = formData.pid;
        var uuid = formData.uuid;

        if (buttonAction === 'increase' && (quantity + 1 <= quantityMax)) {
            quantityNew += 1;
        }

        if (buttonAction === 'decrease' && quantity - 1 >= quantityMin) {
            quantityNew -= 1;
        }

        if (quantityNew !== quantity) {
            var urlParams = {
                pid: productID,
                uuid: uuid,
                quantity: quantityNew
            };
            var url = appendToUrl(formData.action, urlParams);

            $.spinner().start();

            $.ajax({
                url: url,
                type: 'get',
                success: function (data) {
                    $form.data('quantity', quantityNew);
                    $form.find('.item-quantity-value').empty().append(quantityNew);

                    if (quantityNew > quantityMin) {
                        $form.find('.qty-decrease').removeAttr('disabled');
                    }

                    if (quantityNew === quantityMin) {
                        $form.find('.qty-decrease').attr('disabled', true);
                    }

                    if (quantityNew < quantityMax) {
                        $form.find('.qty-increase').removeAttr('disabled');
                    }

                    if (quantityNew === quantityMax) {
                        $form.find('.qty-increase').attr('disabled', true);
                    }

                    updateCartOnQuantityChange(data, productID, uuid, quantity, quantityNew);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('storeFinder:bopisChangeStoreLink', function (e, data) {
        // update order summary when store is changed in cart
        updateCartTotals(data.basket);
        updateApproachingDiscounts(data.basket.approachingDiscounts);
        validateBasket(data.basket);
        klarnaOsm.updateTotal(data.basket.totals.grandTotal.replace(/[NZA$]/g, ''));
        afterpayWidget.getWidget(null, data.basket.totals.grandTotal.replace(/[NZA$]/g, ''), 'cart-afterpay-message');
    });

    if (window.sitePrefs.bopisEnabled && ($('[data-action="Cart-Show"]').length > 0 || $('[data-action="Checkout-Begin"]').length > 0)) {
        require('./cartInstorePickup').init();
    }

    if ($('.cart-page').length) {
        $(document).trigger('update:checkout-step', { checkout_step: 0 });
        utils.checkForSessionLogout();
    }

    klarnaOsm.init();

    import(/* webpackChunkName: "prod-base-chunk" */ '../product/base').then(function (productBase) {
        productBase.selectAttribute();
        productBase.colorAttribute();
        productBase.removeBonusProduct();
        productBase.selectBonusProduct();
        productBase.enableBonusProductSelection();
        productBase.showMoreBonusProducts();
        productBase.addBonusProductsToCart();
        productBase.focusChooseBonusProductModal();
        productBase.trapChooseBonusProductModalFocus();
        productBase.onClosingChooseBonusProductModal();
    });
};
